export const dictionary = {
  EN: {
    HEADER: {
      title: 'Rewards',
      searchBar: 'Search by name'
    },
    TABS: {
      rating: 'Best ratings',
      price: 'Lower price',
      popularity: 'Most popularity',
      recent: 'Recently added',
      cashback: 'Higher cashback',
      bonification: 'Higher bonification',
      bancoppel_emoney: 'More electronic money',
      suburbia_refund: 'Higher refund',
      modal_title: 'Filter by',
      modal_category: 'Categories (up to 3)',
      modal_price: 'Average price',
      modal_price_1: 'Less than 200',
      modal_price_2: 'Between 200 and 500',
      modal_price_3: 'Between 500 and 1,000',
      modal_price_4: 'More than 1,000',
      modal_reward_type: 'Reward type',
      modal_bonification_type: 'Bonification type',
      modal_reward_type_first_time: 'Welcome Reward',
      modal_reward_type_recurring: 'Recurring Reward',
      modal_bonification_type_first_time: 'Welcome Bonification',
      modal_bonification_type_recurring: 'Recurring Bonification',
      modal_business_type: 'Business type',
      modal_business_type_physical: 'Physical venue',
      modal_business_type_ecommerce: 'E-commerce',
      modal_toast: 'You can select up to 3 categories',
      cta: 'Apply filters'
    },
    CARDS: {
      title: 'Rewards designed for you',
      recurring: 'Recurring reward',
      welcome: 'Welcome reward',
      location: 'Location',
      more: 'More',
      emptySocial: 'Coming soon',
      open: 'Open',
      close: 'Close',
      ecommerce: 'e-commerce',
      wait: 'Wait',
      confirmationOutOne: 'You are about to leave the directory',
      confirmationOutTwo: 'Are you sure you want to continue?',
      redirectTooltipOne:
        'Complete your purchase using this link and paying with your card ',
      redirectTooltipOneInvex:
        'Complete your purchase using this link and paying with your credit card ',
      redirectTooltipTwo: 'to receive your benefits',
      continue: 'Continue',
      cancel: 'Cancel',
      check_here: 'Check here the',
      terms_conditions: 'Terms and conditions',
      copy_coupon: 'Copy coupon',
      continue_uber: 'and continue to Uber Eats site'
    },
    EMPTY: {
      title: 'We are sorry 🥲, we are working on improving the options for you',
      cta: 'Go back'
    }
  },
  ES: {
    HEADER: {
      title: 'Comercios',
      searchBar: 'Búsqueda por nombre'
    },
    TABS: {
      rating: 'Mejor rating',
      price: 'Menor precio',
      popularity: 'Más popular',
      recent: 'Recién agregados',
      cashback: 'Mayor cashback',
      bancoppel_emoney: 'Mayor dinero electrónico',
      suburbia_refund: 'Mayor reembolso',
      bonification: 'Mayor bonificación',
      modal_title: 'Filtrar por',
      modal_category: 'Categorías (hasta 3)',
      modal_price: 'Precio promedio',
      modal_price_1: 'Menos de 200',
      modal_price_2: 'Entre 200 y 500',
      modal_price_3: 'Entre 500 y 1,000',
      modal_price_4: 'Más de 1,000',
      modal_reward_type: 'Tipo de recompensa',
      modal_bonification_type: 'Tipo de bonificación',
      modal_business_type: 'Tipo de negocio',
      modal_reward_type_first_time: 'Recompensa de Bienvenida',
      modal_reward_type_recurring: 'Recompensa Recurrente',
      modal_bonification_type_first_time: 'Bonificación de Bienvenida',
      modal_bonification_type_recurring: 'Bonificación Recurrente',
      modal_business_type_physical: 'Negocio físico',
      modal_business_type_ecommerce: 'E-commerce',
      modal_toast: 'Puedes escoger hasta 3 categorías',
      cta: 'Aplicar filtros'
    },
    CARDS: {
      title: 'Recompensas pensadas en ti',
      recurring: 'Recompensa recurrente',
      first_time: 'Recompensa de bienvenida',
      location: 'Locación',
      more: 'Conoce más',
      emptySocial: 'Próximamente',
      open: 'Abierto',
      close: 'Cerrado',
      ecommerce: 'Tienda en línea',
      physicalVenue: 'Negocio físico',
      wait: 'Espera',
      confirmationOutOne: 'Estás a punto de salir del directorio',
      confirmationOutTwo: '¿Quieres continuar?',
      redirectTooltipOne:
        'Completa tu compra usando este enlace y paga con tu tarjeta ',
      redirectTooltipOneInvex:
        'Completa tu compra usando este enlace y paga con tu tarjeta de crédito ',
      redirectTooltipTwo: 'para recibir tus beneficios',
      continue: 'Continuar',
      cancel: 'Cancelar',
      check_here: 'Revisa aqui los',
      terms_conditions: 'Términos y condiciones',
      copy_coupon: 'Copiar cupón',
      continue_uber: ' y continuar al sitio de Uber Eats'
    },
    EMPTY: {
      title: 'Lo sentimos, estamos trabajando en mejorar las opciones para ti',
      cta: 'Regresar'
    }
  }
}
